import { useStaticQuery, graphql } from 'gatsby';

export const useSeoMeta = () => {
  const data = useStaticQuery(
    graphql`
      query seoMetaQuery {
        site {
          siteMetadata {
            title
            siteUrl
            language
          }
        }
        strapiDefaultSeo {
          seo {
            metaTitle
            metaDescription
            metaImage {
              localFile {
                childImageSharp {
                  fluid {
                    src
                  }
                }
              }
              alternativeText
            }
            metaRobots
            keywords
          }
        }
      }
    `
  );
  return data;
};
